/**
 * Theme switch: system / light / dark.
 *
 * The inline script in layout/theme.liquid sets <html data-theme> (what is
 * showing) and <html data-cs-mode> (what was chosen) before first paint. This
 * file owns everything after that:
 *   - the header button cycles system -> light -> dark -> system; "system"
 *     stores nothing and follows the device setting live (sunset auto-switch
 *     included), light/dark are explicit choices kept in localStorage
 *     ("cs-theme")
 *   - other tabs pick up a change through the storage event
 */
(function () {
  const KEY = 'cs-theme';
  const ORDER = ['system', 'light', 'dark'];
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-color-scheme: dark)');

  const mode = () => {
    try {
      const v = localStorage.getItem(KEY);
      return v === 'light' || v === 'dark' ? v : 'system';
    } catch (e) {
      return 'system';
    }
  };
  const store = (v) => {
    try {
      if (v === 'system') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, v);
    } catch (e) {}
  };

  const apply = () => {
    const m = mode();
    const dark = m === 'dark' || (m === 'system' && media.matches);
    root.setAttribute('data-theme', dark ? 'dark' : 'light');
    root.setAttribute('data-cs-mode', m);
    const next = ORDER[(ORDER.indexOf(m) + 1) % ORDER.length];
    const label = `Theme: ${m}. Switch to ${next}`;
    document.querySelectorAll('[data-cs-theme-toggle]').forEach((btn) => {
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cs-theme-toggle]')) return;
    store(ORDER[(ORDER.indexOf(mode()) + 1) % ORDER.length]);
    apply();
  });

  if (media.addEventListener) media.addEventListener('change', apply);
  else if (media.addListener) media.addListener(apply);

  window.addEventListener('storage', (e) => {
    if (e.key === KEY) apply();
  });

  apply();
})();
